<script lang="ts">
export default {
  name: 'CodexPulseLoader',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#0d0d3d'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {
      spinnerStyle: {},
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    }
  },
  created() {
    this.spinnerStyle = {
      backgroundColor: this.color,
      width: this.size,
      height: this.size,
      margin: this.margin,
      borderRadius: this.radius,
      display: 'inline-block',
      animationName: 'v-pulseStretchDelay',
      animationDuration: '0.75s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
      animationFillMode: 'both'
    }
  }
}
</script>

<!-- converted into typescript from vue-spinner's PulseLoader: https://github.com/greyby/vue-spinner/blob/master/src/PulseLoader.vue-->
<template>
  <div v-show="loading" class="vSpinner">
    <div class="v-pulse v-pulse1" :style="[spinnerStyle, spinnerDelay1]" />
    <div class="v-pulse v-pulse2" :style="[spinnerStyle, spinnerDelay2]" />
    <div class="v-pulse v-pulse3" :style="[spinnerStyle, spinnerDelay3]" />
  </div>
</template>

<style>
.vSpinner {
  margin: 10px auto;
  text-align: center;
}

@-webkit-keyframes v-pulseStretchDelay {
  0%,
  80% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-opacity: 1;
    opacity: 1;
  }
  45% {
    -webkit-transform: scale(0.1);
    transform: scale(0.1);
    -webkit-opacity: 0.7;
    opacity: 0.7;
  }
}

@keyframes v-pulseStretchDelay {
  0%,
  80% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-opacity: 1;
    opacity: 1;
  }
  45% {
    -webkit-transform: scale(0.1);
    transform: scale(0.1);
    -webkit-opacity: 0.7;
    opacity: 0.7;
  }
}
</style>
